@if (true) {
  <div
    style="position: absolute; top: 15px; right: 50px; z-index: 100; max-height: 100vh">
    <div
      fxLayout="row"
      fxLayoutAlign="center center">
      @if (languages?.length > 1) {
        <div
          class="mr-4">
          <div class="select is-primary is-small">
            <select
              class="dropdown-item-small"
              [(ngModel)]="selectedCultureCode"
              (ngModelChange)="languageSelected()">
              @for (lang of languages; track lang) {
                <option
                  [ngValue]="lang">
                  {{ getLanguageDisplay(lang) }}
                </option>
              }
            </select>
          </div>
        </div>
      }
      <topo-theme-switcher></topo-theme-switcher>
    </div>
  </div>
}

<div
  class="login-content"
  fxLayout="column"
  fxLayoutAlign="center center">
  <div>
    <div
      class="c24-logo"
      fxLayout="row"
      fxLayoutAlign="center center">
      <div>
        <img
          class="light-logo"
          src="/assets/images/crisis24-logo.svg" />
        <img
          class="dark-logo"
          src="/assets/images/crisis24-logo-reverse.svg" />
      </div>
    </div>
    @if (hasError != false) {
      <div
        class="box is is-elevation-3 login-box"
        >
        <div fxLayoutAlign="center" class="error-icon"><i class="icon icon-small_solid_warning"></i></div>
        <div class="error-sorry">{{ "LOGIN.HORIZON-SSO-ERROR" | translate}}</div>
        <div class="error-redirect">{{ "LOGIN.HORIZON-SSO-ERROR-REDIRECT" | translate}}</div>
      </div>
    }
  </div>
</div>

<div class="glyph"></div>

<topo-spinner></topo-spinner>
